var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "8.001 8.664 518.857 367.054",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8.001 8.664 518.857 367.054",
    height: 384,
    width: 529,
    "data-type": "color",
    role: "img",
    "aria-label": "404 Two illustrated screens with sad faces",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-laqytpwb1 svg [data-color=\"1\"] {fill: #E8E6E6;}\r\n#comp-laqytpwb1 svg [data-color=\"2\"] {fill: #000000;}\r\n#comp-laqytpwb1 svg [data-color=\"3\"] {fill: #FFFFFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "9ab28762-3172-4aaa-81d0-61832d0d30fb_comp-laqytpwb1",
    d: "M1.258 2.241L2.685.786l.013.015-1.44 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4a37b5ff-8ec4-410e-b6e8-98c1e709c80b_comp-laqytpwb1",
    d: "M1.235 2.933L.99.911l.245 2.022z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "454f67b2-34a2-483d-af49-56f4086f6ef2_comp-laqytpwb1",
    d: "M1.326 2.034v-.779.78-.78L1.2.005l.204 2.026-.078-.776v.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ce411724-3211-44af-9d11-31553117a1fe_comp-laqytpwb1",
    d: "M1.917 2.038L.57.508l1.42 1.463-.074.067z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cd437dcd-ac34-4c0f-9a80-35eec205f717_comp-laqytpwb1",
    d: "M1.476 1.826L2.774.63 1.476 1.826zm.8-.765l.818-.747-.819.747z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ef51170c-a43d-478b-b187-1a56d3ea8545_comp-laqytpwb1",
    d: "M3.463 3.624l-.216-2.203.058-.005.158 2.208z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4308b8fe-f2c7-46cd-b17e-39deb0e1d8c0_comp-laqytpwb1",
    d: "M1.524 4.162L1.428 3.06l.096 1.102zm-.062-.468L1.298 1.96l.164 1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0c54cba2-6192-4073-9547-9733b519926c_comp-laqytpwb1",
    d: "M4.102 3.516l-1.43-1.69L4.177 3.45l-.076.067z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#E8E6E6",
    d: "M170.173 363.023c.14 6.083-30.218 11.717-67.806 12.583s-68.174-3.363-68.314-9.447c-.14-6.083 30.218-11.717 67.806-12.583s68.174 3.363 68.314 9.447z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M198.286 286a3.716 3.716 0 0 1-3.7-3.492c-1.878-29.913-10.265-54.515-23.622-69.275a3.739 3.739 0 0 1 .252-5.266 3.703 3.703 0 0 1 5.242.253c14.485 16.009 23.553 42.225 25.534 73.82a3.72 3.72 0 0 1-3.706 3.96z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M129.361 370a3.57 3.57 0 0 1-1.827-.503L111 359.707l.135-2.272c1.176-19.742 3.984-65.95 4.644-68.63.486-1.982 2.461-3.194 4.408-2.691 1.917.486 3.093 2.439 2.667 4.386-.496 3.02-2.805 39.703-4.326 65.108l12.665 7.498c1.735 1.028 2.323 3.29 1.312 5.055a3.62 3.62 0 0 1-3.144 1.839z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M93.36 370c-.621 0-1.25-.162-1.826-.503L75 359.707l.135-2.272c1.176-19.742 3.985-65.95 4.644-68.632.487-1.983 2.461-3.19 4.408-2.69 1.917.486 3.093 2.438 2.669 4.386-.498 3.02-2.807 39.703-4.328 65.109l12.665 7.498c1.735 1.028 2.323 3.29 1.312 5.055A3.622 3.622 0 0 1 93.36 370z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6E6",
    d: "M198.176 137.554l-2.198-2.708a10.502 10.502 0 0 0-9.08-3.85l-95.155 8.41a10.527 10.527 0 0 0-9.141 7.444L43.513 276.14c-1.497 5.21 3.493 8.959 3.493 8.959 7.989 7.591 10.862 12.514 20.678 11.571l82.674-7.927a10.527 10.527 0 0 0 9.142-7.445l40.585-134.017a10.58 10.58 0 0 0-1.909-9.727z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M65.365 298.648c-7.368 0-10.973-3.602-16.173-8.798-1.04-1.038-2.155-2.155-3.396-3.337-.801-.636-5.786-4.894-4.064-10.888L80.828 146.31c1.476-4.874 5.696-8.31 10.752-8.757l95.157-8.41a12.325 12.325 0 0 1 10.68 4.528l2.199 2.707a12.417 12.417 0 0 1 2.244 11.445l-40.584 134.018c-1.477 4.872-5.697 8.308-10.753 8.755l-82.66 7.928c-.882.084-1.712.124-2.499.124zm122.461-165.83c-.254 0-.508.01-.764.033l-95.157 8.41a8.629 8.629 0 0 0-7.527 6.13l-39.09 129.286c-1.121 3.908 2.79 6.902 2.83 6.933l.163.138c1.292 1.229 2.453 2.388 3.53 3.463 5.541 5.537 8.322 8.308 15.696 7.606l82.674-7.927a8.637 8.637 0 0 0 7.542-6.133l40.585-134.017a8.69 8.69 0 0 0-1.569-8.01h-.001l-2.198-2.71a8.642 8.642 0 0 0-6.714-3.204z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M11.717 277a3.713 3.713 0 0 1-3.49-4.988c9.088-24.867 30.463-57.804 60.79-68.79a3.715 3.715 0 1 1 2.53 6.984c-27.922 10.115-47.801 40.988-56.341 64.355A3.716 3.716 0 0 1 11.717 277z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M64.076 294.678c-3.229 0-6.357-1.518-8.163-3.964-1.332-1.804-1.74-3.872-1.147-5.827l38.96-128.699a7.671 7.671 0 0 1 6.69-5.451l96.502-8.532a2.418 2.418 0 0 1 2.186.987 2.44 2.44 0 0 1 .374 2.178l-41.22 136.163a7.673 7.673 0 0 1-6.69 5.45l-86.498 7.648a9.964 9.964 0 0 1-.994.047z",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M197.144 143.124c.481 0 .926.227 1.217.622.171.23.428.715.232 1.355l-41.22 136.162a6.75 6.75 0 0 1-5.885 4.796l-86.513 7.65c-.297.028-.6.042-.9.042-2.94 0-5.783-1.375-7.419-3.59-1.153-1.56-1.51-3.336-1.006-5.002l38.962-128.7a6.75 6.75 0 0 1 5.886-4.796L197 143.13a1.52 1.52 0 0 1 .144-.006m0-1.857c-.1 0-.203.004-.307.013l-96.502 8.533a8.633 8.633 0 0 0-7.496 6.106l-38.962 128.7c-1.682 5.558 3.812 10.99 10.196 10.99.356 0 .716-.017 1.076-.052l86.498-7.648a8.633 8.633 0 0 0 7.495-6.106l41.22-136.163c.669-2.198-.987-4.374-3.218-4.374z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M88.872 170L78 159.351 79.303 158l10.257 10.047 108.276-9.612.164 1.878L88.872 170z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M54.872 278L44 267.352 45.304 266l10.256 10.046 108.278-9.61.162 1.877L54.872 278z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M146.258 234.241l1.427-1.455.013.015-1.44 1.44z",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145 232)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "1e6e3894-8bc3-4e76-bd56-805176c0a8ab_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9ab28762-3172-4aaa-81d0-61832d0d30fb_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#1e6e3894-8bc3-4e76-bd56-805176c0a8ab_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M1.258 2.241l-.015-.015L2.685.786 1.258 2.241z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.235 227.933l-.245-2.022.245 2.022z",
    fill: "#000000",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 225)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "688c1f60-337d-45a6-8b9d-5ee20419e530_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4a37b5ff-8ec4-410e-b6e8-98c1e709c80b_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#688c1f60-337d-45a6-8b9d-5ee20419e530_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M1.188 2.938L.984.911l.25 2.022-.046.005z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M129.326 227.034v-.779.78-.78l-.126-1.25.204 2.026-.078-.776v.78z",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 225)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "2869496a-3499-4dae-bb1d-095e1f2d00a8_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#454f67b2-34a2-483d-af49-56f4086f6ef2_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#2869496a-3499-4dae-bb1d-095e1f2d00a8_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M1.326 2.034L1.2.005l.126-.007v2.036z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M108.917 237.038l-1.347-1.53 1.42 1.463-.074.067z",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107 235)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "1ec9bed6-7a46-489e-84b3-fc2a0576156f_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ce411724-3211-44af-9d11-31553117a1fe_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#1ec9bed6-7a46-489e-84b3-fc2a0576156f_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M1.99 1.97l-.742-.702-.677-.76.025-.02L1.991 1.97z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M109.382 209.637c-1.4-2.053-4.719-2.194-7.415-.316-2.696 1.878-3.746 5.065-2.348 7.118.144.211.321.39.504.561.326-.33.686-.64 1.087-.921 2.417-1.684 5.325-1.731 6.91-.246 1.864-1.883 2.453-4.449 1.262-6.196z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M148.212 211.079c2.416-1.684 5.324-1.733 6.91-.246 1.861-1.883 2.451-4.45 1.26-6.196-1.4-2.053-4.719-2.194-7.415-.316-2.696 1.878-3.746 5.065-2.348 7.118.144.211.32.39.504.561a8 8 0 0 1 1.089-.921z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M112.098 285c-.85 0-1.644-.284-2.23-.87-1.373-1.373-1.086-3.896.64-5.623 1.729-1.723 4.249-2.012 5.624-.641 1.373 1.374 1.086 3.897-.64 5.625-.99.992-2.246 1.509-3.394 1.509zm-.397-5.3c-1.05 1.052-1.344 2.534-.64 3.239.707.706 2.188.412 3.24-.64 1.05-1.052 1.344-2.535.64-3.24-.703-.7-2.188-.41-3.24.641z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#E8E6E6",
    d: "M451.913 340.146c.21 9.118-45.338 17.562-101.733 18.862-56.395 1.3-102.283-5.038-102.493-14.156-.21-9.118 45.338-17.562 101.733-18.862 56.395-1.3 102.283 5.038 102.493 14.156z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M499.615 245a4.15 4.15 0 0 1-.335-.013c-2.236-.182-3.902-2.128-3.72-4.348 3.246-39.444 2.319-114.617-21.737-146.171a4.017 4.017 0 0 1 .786-5.65 4.084 4.084 0 0 1 5.693.781c31.437 41.237 24.279 140.512 23.358 151.696-.177 2.11-1.952 3.705-4.045 3.705z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M389.985 348a3.997 3.997 0 0 1-1.792-.425l-18.833-9.453a9.712 9.712 0 0 1-5.342-9.276c2.743-44.989 6.192-99.339 7.053-102.798a4.013 4.013 0 0 1 4.864-2.928 4.025 4.025 0 0 1 2.934 4.816c-.603 3.262-3.287 43.027-6.843 101.399-.041.665.32 1.29.922 1.59l18.836 9.453a4.034 4.034 0 0 1 1.792 5.4 4.018 4.018 0 0 1-3.59 2.222z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M333.984 348a4.003 4.003 0 0 1-1.792-.425l-18.834-9.453a9.706 9.706 0 0 1-5.34-9.278c2.74-44.986 6.19-99.338 7.051-102.797a4.015 4.015 0 0 1 4.863-2.928 4.026 4.026 0 0 1 2.934 4.816c-.602 3.26-3.286 43.025-6.842 101.4-.041.665.322 1.29.924 1.59l18.835 9.453a4.03 4.03 0 0 1 1.792 5.4 4.013 4.013 0 0 1-3.59 2.222z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6E6",
    d: "M522.255 23.228l-6.755-8.3a11.477 11.477 0 0 0-9.904-4.192L284.421 30.098a11.483 11.483 0 0 0-9.986 8.107l-55.7 183.649a11.492 11.492 0 0 0 3.255 11.83l8.072 7.356a11.48 11.48 0 0 0 8.731 2.951l218.465-19.124c4.575-.371 10.273-3.763 11.635-8.252l55.444-182.799a11.49 11.49 0 0 0-2.082-10.588z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M237.802 246.06a13.53 13.53 0 0 1-9.104-3.524l-8.072-7.355c-3.833-3.495-5.338-8.956-3.83-13.916l55.7-183.649a13.444 13.444 0 0 1 11.747-9.538L505.418 8.716a13.49 13.49 0 0 1 11.65 4.932l6.755 8.3a13.487 13.487 0 0 1 2.449 12.455L470.83 217.201c-1.65 5.444-8.245 9.266-13.41 9.683l-218.45 19.127c-.388.03-.779.048-1.168.048zM506.6 12.717c-.274 0-.551.014-.828.038L284.6 32.118a9.415 9.415 0 0 0-8.226 6.678l-55.702 183.65a9.513 9.513 0 0 0 2.682 9.744l8.072 7.355a9.39 9.39 0 0 0 7.191 2.429l218.463-19.125c3.794-.307 8.77-3.182 9.876-6.821L522.397 33.23a9.457 9.457 0 0 0-1.715-8.72l-6.754-8.302a9.442 9.442 0 0 0-7.328-3.49z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M238.345 243.143c-2.107 0-3.207-.922-3.757-1.695-1.737-2.438-.418-6.47-.263-6.92L289.547 55.74A12.413 12.413 0 0 1 300.352 47l215.602-19.174a6.052 6.052 0 0 1 5.455 2.446 6.06 6.06 0 0 1 .941 5.412c-2.155 7.148-52.805 175.139-54.034 178.66-1.72 4.917-4.734 9.558-15.072 10.21l-214.224 18.56a9.266 9.266 0 0 1-.675.029z",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M516.512 28.81c3.372 0 5.873 3.274 4.872 6.583 0 0-52.786 175.077-54.023 178.618-1.565 4.477-4.17 8.905-14.183 9.538L238.93 242.11a6.89 6.89 0 0 1-.587.024c-5.582 0-3.067-7.277-3.067-7.277L290.51 56.038a11.45 11.45 0 0 1 9.928-8.033l215.603-19.173c.16-.016.316-.022.471-.022m0-2.02c-.214 0-.429.01-.648.03L300.26 45.992a13.419 13.419 0 0 0-11.68 9.45L233.345 234.26c-.153.438-1.614 4.923.416 7.775.688.966 2.042 2.117 4.581 2.117.239 0 .489-.01.751-.03l214.257-18.563c10.88-.687 14.082-5.637 15.913-10.882 1.238-3.541 51.895-171.551 54.05-178.702a7.052 7.052 0 0 0-1.097-6.302 7.035 7.035 0 0 0-5.704-2.883z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M283.683 76L267 60.214l1.41-1.413 16.02 15.159L518.824 54l.176 1.964L283.683 76z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.476 164.826l1.298-1.196-1.298 1.196zm.8-.765l.818-.747-.819.747z",
    fill: "#000000",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422 163)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "78102787-6477-40e5-8489-ca4147b6b625_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cd437dcd-ac34-4c0f-9a80-35eec205f717_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#78102787-6477-40e5-8489-ca4147b6b625_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M1.486 1.836l.818-.746-.818.746zm.319-.312L3.103.326 1.805 1.524z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M388.463 153.624l-.216-2.203.058-.005.158 2.208z",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385 150)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "2eb09022-8f2e-4ea3-8787-ac6985be23fe_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ef51170c-a43d-478b-b187-1a56d3ea8545_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#2eb09022-8f2e-4ea3-8787-ac6985be23fe_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M3.43 3.626l-.183-2.205.183 2.205z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.524 152.162l-.096-1.102.096 1.102zm-.062-.468l-.164-1.734.164 1.733z",
    fill: "#000000",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(387 148)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "13883d63-7395-4e9f-a112-11caac86d958_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4308b8fe-f2c7-46cd-b17e-39deb0e1d8c0_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#13883d63-7395-4e9f-a112-11caac86d958_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M1.507 4.164l-.163-1.733.163 1.733zm-.13-1.1l-.095-1.1.096 1.1z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M345.102 171.516l-1.43-1.69 1.505 1.624-.076.067z",
    fillRule: "nonzero",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341 168)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "278521b4-9ad1-4cda-a6f1-3dee9410a0e6_comp-laqytpwb1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0c54cba2-6192-4073-9547-9733b519926c_comp-laqytpwb1"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#278521b4-9ad1-4cda-a6f1-3dee9410a0e6_comp-laqytpwb1)",
    fillRule: "nonzero",
    fill: "#000000",
    d: "M4.178 3.449l-.792-.778-.698-.857 1.49 1.635z",
    "data-color": 2
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M197.027 267c-.257 0-.519-.026-.78-.077-2.18-.433-3.599-2.565-3.17-4.761 2.161-11.064 22.317-109.01 63.474-140.342a4.004 4.004 0 0 1 5.635.789 4.075 4.075 0 0 1-.783 5.678c-31.493 23.974-52.803 96.416-60.431 135.443a4.034 4.034 0 0 1-3.945 3.27z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M429.422 118.158c4.835-3.369 10.65-3.462 13.822-.491 3.724-3.768 4.901-8.899 2.52-12.393-2.8-4.106-9.437-4.388-14.829-.63-5.392 3.756-7.495 10.128-4.696 14.232.29.424.643.782 1.008 1.124a15.808 15.808 0 0 1 2.175-1.842z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M309.489 64c-.956 0-1.847-.319-2.505-.977-.772-.775-1.115-1.923-.939-3.15.165-1.145.754-2.272 1.66-3.177 1.942-1.941 4.773-2.264 6.32-.72 1.542 1.545 1.22 4.384-.72 6.327C312.189 63.42 310.78 64 309.49 64zm2.025-7.114c-.789 0-1.728.407-2.473 1.153-.608.61-1.017 1.376-1.122 2.107-.053.37-.072 1.06.405 1.538.476.477 1.169.46 1.536.405.73-.105 1.498-.514 2.104-1.125 1.181-1.182 1.51-2.853.72-3.642-.293-.297-.706-.436-1.17-.436z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M322.484 63c-.957 0-1.85-.318-2.507-.976-1.545-1.544-1.222-4.378.72-6.32.905-.903 2.034-1.493 3.177-1.657 1.222-.18 2.374.164 3.15.94 1.544 1.543 1.221 4.378-.72 6.319-1.115 1.115-2.528 1.694-3.82 1.694zm2.026-7.104c-.138 0-.263.012-.364.026-.73.105-1.5.514-2.106 1.124-1.185 1.18-1.514 2.849-.72 3.64.792.792 2.462.461 3.642-.72.61-.608 1.02-1.374 1.126-2.103.053-.37.072-1.06-.406-1.536-.345-.345-.806-.431-1.172-.431z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M337.484 62c-.957 0-1.85-.319-2.507-.977-1.545-1.544-1.222-4.382.72-6.325 1.941-1.944 4.778-2.267 6.326-.72 1.545 1.544 1.222 4.382-.72 6.325-1.116 1.115-2.527 1.697-3.82 1.697zm2.03-7.113c-.792 0-1.73.407-2.476 1.153-1.183 1.183-1.514 2.85-.72 3.642.792.796 2.462.463 3.642-.72 1.183-1.182 1.514-2.85.72-3.641-.292-.296-.703-.434-1.166-.434z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M330.422 127.158c4.835-3.369 10.65-3.462 13.822-.491 3.724-3.768 4.901-8.899 2.52-12.393-2.8-4.106-9.437-4.388-14.829-.63-5.392 3.756-7.495 10.128-4.696 14.232.29.424.643.782 1.008 1.124a15.413 15.413 0 0 1 2.175-1.842z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M108.04 234.356c14.412-12.22 27.895-13.284 39.945-2.997a1.5 1.5 0 0 1-1.948 2.282c-10.846-9.26-22.697-8.324-36.056 3.003a1.5 1.5 0 1 1-1.94-2.288z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    d: "M359.909 159.013c23.876-15.545 44.347-17.18 61.02-4.61a2 2 0 1 1-2.407 3.194c-15.162-11.43-33.842-9.938-56.43 4.768a2 2 0 1 1-2.183-3.352z",
    "data-color": 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.729db48fde26aefda606a4814d2846ce.svg";
export { ForwardRef as ReactComponent };